import { useBrPageContext } from "../../context/context/context.js";
const useBloomreachPageModels = () => {
  const page = useBrPageContext();
  return page?.getComponent().getModels();
};
export {
  useBloomreachPageModels
};
//# sourceMappingURL=use-bloomreach-page-models.js.map
